import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {StatementItemContentFragment} from "../fragments/statementItemContent"

const query = gql`
  query StatementItems($walletId: String!, $cursor: String, $knownTypes: [String!]) {
    statementItems(walletId: $walletId, cursor: $cursor, knownTypes: $knownTypes) {
      cursor
      results {
        uuid
        transactionId
        transactionType
        content {
          ...StatementItemContentFragment
        }
        transfer {
          uuid
          amount
          currency
          createdAt
          type
          message
          destinationIds
          rewardedUsers {
            firstName
            lastName
          }
          spend {
            dealHeader
            dealThumbnailImage
            orderTotal {
              currency
              value
            }
            redemptionUuid
          }
          sourceUser {
            firstName
            lastName
            email
          }
          walletType
        }
      }
    }
  }

  ${StatementItemContentFragment}
`

export const statementItemsQueryKey = getQueryNames(query)[0]

export default query
